<template>
  <div>
    <v-card class="elevation-0">
      <v-toolbar card color="white">
        <v-text-field
          flat
          solo
          hide-details
          prepend-icon="search"
          placeholder="Tìm trên danh sách sim"
          v-model="table.searchText"
        ></v-text-field>
        <v-tooltip bottom>
          <v-btn icon slot="activator" @click="exportToExcel()">
            <v-icon>save_alt</v-icon>
          </v-btn>
          <span>Tải về danh sách sim</span>
        </v-tooltip>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text class="pa-0">
        <v-data-table
          item-key="id"
          :headers="table.headers"
          :search="table.searchText"
          :items="datasource"
          :rows-per-page-items="[10,20,50,100]"
          :loading="isLoading"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.iccId }}</td>
            <td>{{ props.item.phone }}</td>
            <td>{{ props.item.telco }}</td>
            <td>{{ getDateFormatted(props.item.telcoActivationDate) }}</td>
            <td>{{ props.item.prepaid }}</td>
            <td>{{ props.item.prepaidAmount }}</td>
            <td>{{ props.item.data }}</td>
            <td>{{ props.item.remark }}</td>
            <td>
              <v-chip
                v-if="props.item.errCode"
                small
                color="red"
                text-color="white"
              >{{props.item.errCode}}</v-chip>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import XLSX from 'xlsx';
import moment from 'moment';

export default {
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    datasource: {
      type: Array,
      default: []
    }
  },
  data () {
    return {
      table: {
        searchText: '',
        headers: [
          {
            text: 'ICCID',
            value: 'iccId'
          },
          {
            text: 'SĐT',
            value: 'phone'
          },
          {
            text: 'Nhà mạng',
            value: 'telco'
          },
          {
            text: 'Ngày kích hoạt (Nhà mạng)',
            value: 'telcoActivationDate'
          },
          {
            text: 'Trả trước',
            value: 'prepaid'
          },
          {
            text: 'Số dư (trả trước)',
            value: 'prepaidAmount'
          },
          {
            text: 'Dung lượng (KB)',
            value: 'data'
          },
          {
            text: 'Ghi chú',
            value: 'remark'
          },
          {
            text: 'Lỗi (Nếu có)',
            value: 'errCode'
          }
        ]
      }
    };
  },
  methods: {
    getDateFormatted: value => {
      return value ? moment(value).format('YYYY-MM-DD') : '';
    },
    exportToExcel () {
      if (this.datasource.length > 0) {
        let dataToExport = [];
        this.datasource.map((item, index) => {
          let data = {
            STT: ++index,
            ICCID: item.iccid,
            'Số điện thoại': item.phone,
            'Nhà mạng': item.telco,
            'Ngày kích hoạt (Nhà mạng)': item.telcoActivationDate,
            'Trả trước': item.prepaid,
            'Số dư (trả trước)': item.prepaidAmount,
            'Dung lượng (KB)': item.data,
            'Ghi chú': item.remark,
            'Lỗi (Nếu có)': item.errCode
          };
          dataToExport.push(data);
          return 0;
        });

        let sheet = XLSX.utils.json_to_sheet(dataToExport);
        let wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, sheet, 'Sims');
        XLSX.writeFile(wb, 'Sims.xlsx');
      } else {
        window.getApp.showMessage('Không có dữ liệu', 'error');
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/sim/components/importlist.vue